function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWWolontariat = function SvgWWolontariat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Warstwa 1",
    viewBox: "0 0 155.5 155.5"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M130.71 49.12v61.75c0 11.08-9.02 20.1-20.1 20.1s-20.1-9.02-20.1-20.1H66.23c0 24.47 19.91 44.37 44.37 44.37s44.38-19.91 44.38-44.37V49.12H130.7Z",
    style: {
      fill: "#e41f13"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.24 49.12v61.75c0 11.08-9.02 20.1-20.1 20.1s-20.1-9.02-20.1-20.1V49.12H1.77v61.75c0 24.47 19.91 44.37 44.38 44.37s44.37-19.91 44.37-44.37V49.12z",
    style: {
      fill: "#091f2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h155.5v155.5H0z",
    style: {
      fill: "none"
    }
  }));
};
export default SvgWWolontariat;